// ----------------------------------------------------------------------

export default function Label(theme: any) {
  return {
    MuiTableSortLabel: {
      styleOverrides: {
        root: {
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        },
      },
    },
  };
}
